<bn-care-plan-item-card>
  <div carePlanCardMain>
    <h4 class="bn-option-card__title m-0">{{ option().title }}</h4>
    @if (option().description) {
      <p class="bn-option-card__description m-0">{{ option().description }}</p>
    }
    <p class="bn-option-card__type m-0">{{ typeLabel() }}</p>
  </div>

  <div carePlanCardActions class="bn-option-card__actions">
    @if (canTransition()) {
      <bn-care-plan-status-select
        [options]="statusOptions()"
        ariaLabel="Option status"
        [placeholder]="statusLabel()"
        [value]="displayedStatusCode()"
        [loading]="store().isSaving(option().id)"
        [disabled]="store().isSaving(option().id)"
        (valueChange)="onStatusChange($event)"
      />
    } @else {
      <span [class]="statusClass()">
        {{ statusLabel() }}
      </span>
    }
    @if (!readonly()) {
      <button type="button" class="bn-option-card__edit" (click)="openEdit()">
        View/Edit
      </button>
    }
  </div>
</bn-care-plan-item-card>
